export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
    window.theme.nosto?.attribution?.applyPendingToForms()
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    const state = await window.BAO.Cart.addItemFromForm(this.form)
    window.theme.nosto?.attribution?.onProductFormAdd(this.form, state)
    return state
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
